export const translations = {
  es: {
    nav: {
      pillars: "Pilares",
      method: "Método",
      coach: "Sobre Mí",
      services: "Servicios",
      apply: "Aplicar",
      admin: "Admin",
    },
    hero: {
      eyebrow: "MINDSET · TRAINING · KNOWLEDGE",
      title1: "No necesitas más motivación.",
      title2: "Necesitas un sistema que te obligue a cambiar.",
      subtitle:
        "MTK System es una mentoría integral basada en entrenamiento, disciplina y estructura mental para transformar tu físico, tu rendimiento y tu estilo de vida.",
      ctaPrimary: "APLICAR A CAMBIO TOTAL",
      ctaSecondary: "VER MÉTODO",
      subcta: "Acceso limitado · Solo personas comprometidas",
      stat1: "Mentoría",
      stat1v: "1:1",
      stat2: "Plazas",
      stat2v: "Limitadas",
      stat3: "Filtro",
      stat3v: "Selectivo",
    },
    reality: {
      eyebrow: "REALIDAD ACTUAL",
      title1: "El problema no es que no lo intentes.",
      title2: "Es que no tienes dirección.",
      lead: "Llevas tiempo intentando mejorar:",
      points: [
        "Empiezas rutinas que no mantienes.",
        "No tienes estructura ni seguimiento.",
        "Comes 'más o menos bien' sin estrategia.",
        "Tu energía, disciplina y enfoque son inestables.",
      ],
      worst: "Y lo peor:",
      worstLine: "Sabes que podrías estar mucho mejor… pero no sabes cómo sostenerlo.",
    },
    whatIs: {
      eyebrow: "QUÉ ES MTK SYSTEM",
      title: "MTK no es entrenamiento. Es un sistema de cambio.",
      lead: "MTK System es una mentoría estructurada que integra:",
      points: [
        "Entrenamiento físico inteligente",
        "Reestructuración de hábitos",
        "Control mental y disciplina operativa",
        "Educación real para que entiendas lo que haces",
      ],
      footer1: "No trabajamos solo tu físico.",
      footer2: "Trabajamos cómo vives.",
    },
    pillars: {
      eyebrow: "LOS 3 PILARES",
      title: "Tres dominios. Un mismo sistema.",
      mindset: {
        tag: "01 / MINDSET",
        title: "MINDSET",
        items: [
          "Eliminación de conductas autolimitantes",
          "Desarrollo de disciplina diaria",
          "Control de estímulos y entorno",
          "Enfoque y claridad mental",
        ],
        quote: "Sin mentalidad, no hay cambio sostenible.",
      },
      training: {
        tag: "02 / TRAINING",
        title: "TRAINING",
        items: [
          "Entrenamiento adaptado a tu nivel y contexto",
          "Progresión estructurada (no improvisación)",
          "Mejora de fuerza, composición y rendimiento",
          "Integración con tu vida real",
        ],
        quote: "Entrenas con intención. No por inercia.",
      },
      knowledge: {
        tag: "03 / KNOWLEDGE",
        title: "KNOWLEDGE",
        items: [
          "Entiendes el por qué de cada decisión",
          "Aprendes a gestionar tu cuerpo y energía",
          "Tomas control progresivo de tu proceso",
        ],
        quote: "No dependes de mí. Evolucionas contigo.",
      },
    },
    science: {
      eyebrow: "ENFOQUE PROFESIONAL",
      title: "Método basado en ciencia. Aplicado a la vida real.",
      lead: "El sistema MTK se apoya en principios avanzados:",
      items: [
        "Regulación de carga y fatiga",
        "Optimización de hábitos y adherencia",
        "Mejora de la eficiencia metabólica",
        "Adaptación progresiva del sistema nervioso",
      ],
      key: "Pero lo importante:",
      keyLine:
        "No necesitas entender la ciencia. Necesitas un sistema que funcione en tu día a día.",
    },
    forWho: {
      eyebrow: "FILTRO DE ACCESO",
      title: "Esto es para personas que quieren cambiar de verdad.",
      yes: "MTK ES PARA TI SI",
      no: "NO ES PARA TI SI",
      yesItems: [
        "Estás cansado de empezar y abandonar",
        "Sabes que tienes más potencial del que estás usando",
        "Quieres disciplina, estructura y resultados reales",
        "Estás dispuesto a comprometerte",
      ],
      noItems: [
        "Buscas algo cómodo",
        "No aceptas exigencia",
        "No estás listo para cambiar hábitos",
      ],
    },
    inflection: {
      eyebrow: "CAMBIO TOTAL",
      title: "No es un programa. Es un punto de inflexión.",
      lead: "El objetivo no es que entrenes mejor. El objetivo es que:",
      items: [
        "Tengas control sobre tu cuerpo",
        "Tengas control sobre tu mente",
        "Tengas estructura en tu vida",
      ],
      footer: "Sales del proceso siendo otra persona.",
    },
    coach: {
      eyebrow: "QUIÉN SOY",
      title: "No enseño teoría. Aplico lo que vivo.",
      name: "Xoel Crespo",
      role: "Fundador de MTK System · Entrenador · Atleta de CrossFit · Especialista en Ciencias del Ejercicio",
      intro:
        "Mi vida siempre ha estado ligada al deporte, al rendimiento y a la disciplina. Desde los 4 años crecí compitiendo. Cualquier entorno donde hubiera exigencia, mejora y superación.",
      chapters: [
        {
          tag: "01 / ORÍGENES",
          title: "Deporte como forma de vida",
          paragraphs: [
            "Fútbol, atletismo, tenis… competir era el lenguaje natural.",
            "Mi infancia y adolescencia transcurrieron entre el Pabellón de los Remedios, el Bamio y diferentes estructuras deportivas de Ourense. No era solo actividad física: era una forma de vida.",
          ],
        },
        {
          tag: "02 / COMPETICIÓN",
          title: "Fútbol semiprofesional · decisiones que marcan",
          paragraphs: [
            "Durante años desarrollé mi carrera en el fútbol, compitiendo en categorías exigentes.",
            "En paralelo, tomé decisiones que marcaron mi mentalidad competitiva desde joven, como elegir entre competir en un Campeonato de España de tenis o representar a la Selección Gallega de fútbol. Elegí competir.",
          ],
          stats: [
            "División de Honor Juvenil (máxima categoría nacional)",
            "UD Ourense · Antela FC · Atlético Arnoia · Verín CF",
            "2 ascensos a 3ª RFEF",
            "Copa Diputación",
          ],
        },
        {
          tag: "03 / DISCIPLINA",
          title: "3 años en Policía Local",
          paragraphs: [
            "Durante 3 años trabajé en diferentes cuerpos de Policía Local. Esa etapa, combinada con el deporte semiprofesional, consolidó mi mentalidad de trabajo, estructura y responsabilidad.",
          ],
          quote: "La disciplina no es opcional. Es la base de todo cambio real.",
        },
        {
          tag: "04 / INFLEXIÓN",
          title: "El punto de inflexión",
          paragraphs: [
            "Tras finalizar mi etapa como futbolista, decidí dedicarme al 100% a lo que realmente define mi propósito: el entrenamiento, el rendimiento y la transformación personal.",
            "Desde entonces he construido mi carrera como entrenador, formándome de manera continua y aplicando todo el conocimiento en un entorno real con personas.",
          ],
        },
        {
          tag: "05 / FORMACIÓN",
          title: "Práctica + ciencia",
          paragraphs: ["Mi enfoque combina práctica y ciencia."],
          stats: [
            "Formación en Acondicionamiento Físico",
            "Entrenador Nacional de Natación (RFEN)",
            "Certificación profesional en Salvamento Acuático (UE)",
            "Entrenamiento concurrente",
            "CrossFit HQ",
            "Nutrición deportiva",
            "Fisiología y sistemas energéticos",
            "Optimización hormonal y rendimiento",
          ],
          mentorsLabel: "Aprendizaje de referentes",
          mentors: ["Marcos Vázquez", "Dr. Borja Bandera", "Ismael Galancho"],
        },
        {
          tag: "06 / EXPERIENCIA",
          title: "Dónde aplico el sistema hoy",
          blocks: [
            {
              title: "Universidad de Vigo",
              subtitle: "Campus Ourense · Servicio de Deportes",
              items: [
                "Dirección técnica del área de entrenamiento",
                "Atención a deportistas",
                "Planificación y control de cargas",
              ],
            },
            {
              title: "MTK System",
              subtitle: "Fundador & Head Coach",
              items: [
                "Programación individualizada",
                "Seguimiento y análisis de métricas",
                "Aplicación de fisiología y neurociencia",
                "Coaching 1:1 en hábitos y estilo de vida",
              ],
            },
            {
              title: "Investigación aplicada",
              subtitle: "Ciencias del deporte",
              items: [
                "Proyectos en ciencias del deporte",
                "Recogida de datos en población universitaria",
                "Aplicación al entrenamiento de fuerza",
              ],
            },
          ],
          previousLabel: "Experiencia previa",
          previous: [
            "Coach en CrossFit RockLife",
            "Profesor de natación · Colegio Miraflores",
            "Cofundador de MUR Project (gimnasio)",
            "Cuerpos de Policía Local",
          ],
        },
        {
          tag: "07 / ATLETA",
          title: "Atleta en activo",
          paragraphs: [
            "Actualmente compito en CrossFit. Eso me permite mantener contacto directo con el rendimiento real, aplicar en mí mismo lo que enseño y validar cada método desde la práctica.",
          ],
          quote: "No trabajo desde la teoría. Trabajo desde la experiencia.",
        },
      ],
      approachTitle: "Mi enfoque",
      approachIntro:
        "No creo en soluciones rápidas. No creo en motivación vacía. Creo en:",
      approach: [
        "Sistemas estructurados",
        "Disciplina diaria",
        "Progresión medible",
        "Responsabilidad personal",
      ],
      missionTitle: "Mi misión",
      missionLines: [
        "Ayudar a personas a salir de la mediocridad física y mental.",
        "No solo entrenar mejor. Vivir mejor.",
        "MTK System no busca cambios temporales. Busca transformación real.",
      ],
    },
    services: {
      eyebrow: "SERVICIOS",
      title: "Dos formas de trabajar conmigo.",
      mentorship: {
        tag: "MENTORÍA · FLAGSHIP",
        title: "CAMBIO TOTAL",
        subtitle: "Transformación guiada · acceso por filtro",
        items: [
          "Seguimiento completo",
          "Control de hábitos",
          "Planificación de entrenamiento",
          "Evaluación continua",
          "Contacto directo",
          "Exigencia real",
        ],
        cta: "APLICAR AHORA",
        tagline: "Esto es transformación guiada.",
      },
      personal: {
        tag: "1:1",
        title: "ENTRENAMIENTOS PERSONALES",
        subtitle: "Sesiones individuales presenciales",
        items: [
          "Sesiones 1:1",
          "Adaptación total a tu nivel",
          "Corrección técnica",
          "Intensidad controlada",
          "Mejora progresiva",
        ],
        cta: "RESERVAR SESIÓN",
        tagline: "Entrenas con intención. No por inercia.",
      },
    },
    results: {
      eyebrow: "RESULTADOS",
      title: "Lo que ocurre cuando aplicas un sistema real",
      items: [
        "Mejora física visible",
        "Reducción de grasa / aumento de masa muscular",
        "Más energía y claridad mental",
        "Disciplina en tu día a día",
        "Confianza real",
      ],
    },
    testimonials: {
      eyebrow: "TESTIMONIOS",
      title: "No teoría. Resultados.",
      items: [
        {
          quote:
            "Pasé de empezar y abandonar cada dos meses a tener un sistema que sostengo todos los días. La diferencia no fue la motivación. Fue la estructura.",
          name: "Carlos M.",
          role: "Ejecutivo · 7 meses en MTK",
        },
        {
          quote:
            "Bajé 11 kg de grasa, gané fuerza real y, sobre todo, dejé de depender de la motivación. Cambió mi forma de comer, dormir y trabajar.",
          name: "Lucía R.",
          role: "Médica · 5 meses en MTK",
        },
        {
          quote:
            "No es 'otro entrenador'. Xoel exige, mide y ajusta. La diferencia con cualquier app o plantilla es brutal.",
          name: "David A.",
          role: "Empresario · 9 meses en MTK",
        },
      ],
    },
    limited: {
      eyebrow: "ACCESO LIMITADO",
      title: "No todo el mundo entra.",
      points: [
        "Trabajo con un número reducido de personas",
        "Cada solicitud es evaluada",
        "Solo acceden perfiles comprometidos",
      ],
    },
    finalCta: {
      eyebrow: "ÚLTIMO PASO",
      title: "Si estás listo para cambiar de verdad, aplica ahora.",
      cta: "APLICAR A MTK SYSTEM",
      subcopy: "Proceso de selección · Respuesta en 24–48h",
    },
    form: {
      eyebrow: "FORMULARIO DE APLICACIÓN",
      title: "Aplica a Cambio Total",
      subtitle: "Sé honesto. Las solicitudes vagas se descartan.",
      labels: {
        name: "Nombre completo",
        email: "Email",
        age: "Edad",
        situation: "Situación actual (trabajo, rutina, nivel físico)",
        objective: "Objetivo principal",
        time: "Tiempo disponible semanal",
        block: "¿Qué te frena actualmente?",
        why: "¿Por qué quieres entrar en MTK?",
      },
      submit: "ENVIAR APLICACIÓN",
      sending: "Enviando…",
      successTitle: "Solicitud recibida.",
      successCopy:
        "Revisaremos tu aplicación. Si encajas, te contactaremos en 24–48h.",
      reset: "ENVIAR OTRA",
      feeNoticeTitle: "Fee de compromiso · €100 reembolsable",
      feeNoticeCopy:
        "Aplicar implica un compromiso financiero de €100 (reembolsables si no encajas en el sistema). Filtra a curiosos y valida intención real.",
      paying: "Redirigiendo a pago seguro…",
      paySubmit: "PAGAR Y APLICAR · €{amount}",
      placeholders: {
        name: "Tu nombre",
        email: "tu@email.com",
        age: "Ej. 32",
        situation: "Cuéntame tu día a día, profesión, hábitos y nivel actual…",
        objective: "Qué quieres conseguir en los próximos 6 meses",
        time: "Ej. 4–5h semanales",
        block: "Qué te ha impedido sostenerlo hasta ahora",
        why: "Por qué ahora, por qué MTK, qué estás dispuesto a hacer",
      },
    },
    footer: {
      tagline: "Mindset · Training · Knowledge",
      copy: "Sistema de transformación guiada. Acceso limitado. Solo personas comprometidas.",
      rights: "Todos los derechos reservados.",
    },
    admin: {
      loginTitle: "Acceso Administrador",
      loginSubtitle: "Ingresa para revisar las aplicaciones.",
      email: "Email",
      password: "Contraseña",
      login: "INICIAR SESIÓN",
      loggingIn: "Entrando…",
      dashboardTitle: "PANEL DE APLICACIONES",
      logout: "Salir",
      filterAll: "Todas",
      filterPending: "Pendientes",
      filterAccepted: "Aceptadas",
      filterRejected: "Rechazadas",
      filterPaid: "Pagadas",
      filterUnpaid: "Sin Pago",
      noApps: "No hay aplicaciones aún.",
      view: "Ver",
      accept: "Aceptar",
      reject: "Rechazar",
      reset: "Reset",
      delete: "Eliminar",
      saveNotes: "Guardar Notas",
      notes: "Notas internas",
      total: "Total",
      pending: "Pendientes",
      accepted: "Aceptadas",
      rejected: "Rechazadas",
      paid: "Pagadas",
      paidBadge: "PAGADA",
      unpaidBadge: "SIN PAGO",
    },
    blog: {
      title: "Blog",
      readMore: "Leer artículo",
      backToBlog: "← Volver al Blog",
      noPosts: "Próximamente...",
      by: "Por",
      newPost: "Crear blog",
      publish: "Publicar",
      unpublish: "Despublicar",
      draft: "Borrador",
      published: "Publicado",
      titleLabel: "Título",
      excerptLabel: "Extracto (opcional)",
      contentLabel: "Contenido",
      authorLabel: "Autor",
      save: "Guardar",
      saving: "Guardando…",
      cancel: "Cancelar",
      confirmDelete: "¿Eliminar este artículo?",
      manageBlog: "GESTIÓN BLOG",
      noBlogPosts: "No hay artículos aún.",
    },
  },
  en: {
    nav: {
      pillars: "Pillars",
      method: "Method",
      coach: "About Me",
      services: "Services",
      apply: "Apply",
      admin: "Admin",
    },
    hero: {
      eyebrow: "MINDSET · TRAINING · KNOWLEDGE",
      title1: "You don't need more motivation.",
      title2: "You need a system that forces you to change.",
      subtitle:
        "MTK System is an integral mentorship based on training, discipline and mental structure to transform your body, your performance and your lifestyle.",
      ctaPrimary: "APPLY TO TOTAL CHANGE",
      ctaSecondary: "SEE METHOD",
      subcta: "Limited access · Committed people only",
      stat1: "Mentorship",
      stat1v: "1:1",
      stat2: "Spots",
      stat2v: "Limited",
      stat3: "Filter",
      stat3v: "Selective",
    },
    reality: {
      eyebrow: "CURRENT REALITY",
      title1: "The problem isn't that you don't try.",
      title2: "It's that you have no direction.",
      lead: "You've been trying to improve for a while:",
      points: [
        "You start routines you can't sustain.",
        "You have no structure or follow-up.",
        "You eat 'more or less well' with no strategy.",
        "Your energy, discipline and focus are unstable.",
      ],
      worst: "And the worst part:",
      worstLine: "You know you could be much better… but you don't know how to sustain it.",
    },
    whatIs: {
      eyebrow: "WHAT IS MTK SYSTEM",
      title: "MTK is not training. It is a system of change.",
      lead: "MTK System is a structured mentorship integrating:",
      points: [
        "Intelligent physical training",
        "Habit restructuring",
        "Mental control and operational discipline",
        "Real education so you understand what you do",
      ],
      footer1: "We don't only work your body.",
      footer2: "We work how you live.",
    },
    pillars: {
      eyebrow: "THE 3 PILLARS",
      title: "Three domains. One system.",
      mindset: {
        tag: "01 / MINDSET",
        title: "MINDSET",
        items: [
          "Elimination of self-limiting behaviors",
          "Daily discipline development",
          "Stimuli and environment control",
          "Focus and mental clarity",
        ],
        quote: "Without mindset, there is no sustainable change.",
      },
      training: {
        tag: "02 / TRAINING",
        title: "TRAINING",
        items: [
          "Training adapted to your level and context",
          "Structured progression (no improvisation)",
          "Strength, composition and performance",
          "Integration with your real life",
        ],
        quote: "Train with intent. Not inertia.",
      },
      knowledge: {
        tag: "03 / KNOWLEDGE",
        title: "KNOWLEDGE",
        items: [
          "Understand the why of every decision",
          "Learn to manage your body and energy",
          "Take progressive control of your process",
        ],
        quote: "You don't depend on me. You evolve with yourself.",
      },
    },
    science: {
      eyebrow: "PROFESSIONAL APPROACH",
      title: "Science-based method. Applied to real life.",
      lead: "MTK is supported by advanced principles:",
      items: [
        "Load and fatigue regulation",
        "Habit and adherence optimization",
        "Metabolic efficiency improvement",
        "Progressive nervous system adaptation",
      ],
      key: "But the important thing:",
      keyLine:
        "You don't need to understand the science. You need a system that works in your day-to-day.",
    },
    forWho: {
      eyebrow: "ACCESS FILTER",
      title: "This is for people who want to truly change.",
      yes: "MTK IS FOR YOU IF",
      no: "IT'S NOT FOR YOU IF",
      yesItems: [
        "You're tired of starting and quitting",
        "You know you have more potential than you're using",
        "You want discipline, structure and real results",
        "You are willing to commit",
      ],
      noItems: [
        "You're looking for something easy",
        "You don't accept demand",
        "You're not ready to change habits",
      ],
    },
    inflection: {
      eyebrow: "TOTAL CHANGE",
      title: "It's not a program. It's a turning point.",
      lead: "The goal is not that you train better. The goal is that:",
      items: [
        "You have control over your body",
        "You have control over your mind",
        "You have structure in your life",
      ],
      footer: "You leave the process being someone else.",
    },
    coach: {
      eyebrow: "WHO I AM",
      title: "I don't teach theory. I apply what I live.",
      name: "Xoel Crespo",
      role: "Founder of MTK System · Coach · CrossFit Athlete · Exercise Science Specialist",
      intro:
        "My life has always been tied to sport, performance and discipline. Since the age of 4 I grew up competing — any environment with demand, improvement and surpassing oneself.",
      chapters: [
        {
          tag: "01 / ORIGINS",
          title: "Sport as a way of life",
          paragraphs: [
            "Football, athletics, tennis… competing was the natural language.",
            "My childhood and adolescence took place between Pabellón de los Remedios, Bamio and different sports structures in Ourense. It wasn't just physical activity: it was a way of life.",
          ],
        },
        {
          tag: "02 / COMPETITION",
          title: "Semi-pro football · decisions that shape you",
          paragraphs: [
            "For years I built my football career, competing in demanding categories.",
            "In parallel, I made decisions that shaped my competitive mindset early on — like choosing between competing in a Spanish Tennis Championship or representing the Galician Football Team. I chose to compete.",
          ],
          stats: [
            "División de Honor Juvenil (top national category)",
            "UD Ourense · Antela FC · Atlético Arnoia · Verín CF",
            "2 promotions to 3rd RFEF",
            "Copa Diputación",
          ],
        },
        {
          tag: "03 / DISCIPLINE",
          title: "3 years in Local Police",
          paragraphs: [
            "For 3 years I worked in different Local Police corps. Combined with semi-pro sport, that period consolidated my mindset of work, structure and responsibility.",
          ],
          quote: "Discipline is not optional. It is the base of every real change.",
        },
        {
          tag: "04 / TURNING POINT",
          title: "The turning point",
          paragraphs: [
            "After ending my football career, I decided to dedicate 100% to what truly defines my purpose: training, performance and personal transformation.",
            "Since then, I've built my career as a coach — training continuously and applying every piece of knowledge in a real environment with real people.",
          ],
        },
        {
          tag: "05 / EDUCATION",
          title: "Practice + science",
          paragraphs: ["My approach combines practice and science."],
          stats: [
            "Physical Conditioning",
            "National Swimming Coach (RFEN)",
            "Aquatic Lifesaving Certification (EU)",
            "Concurrent training",
            "CrossFit HQ",
            "Sports nutrition",
            "Physiology and energy systems",
            "Hormonal optimization and performance",
          ],
          mentorsLabel: "Learning from references",
          mentors: ["Marcos Vázquez", "Dr. Borja Bandera", "Ismael Galancho"],
        },
        {
          tag: "06 / EXPERIENCE",
          title: "Where I apply the system today",
          blocks: [
            {
              title: "University of Vigo",
              subtitle: "Ourense Campus · Sports Service",
              items: [
                "Technical direction of training area",
                "Athlete attention",
                "Load planning and control",
              ],
            },
            {
              title: "MTK System",
              subtitle: "Founder & Head Coach",
              items: [
                "Individualized programming",
                "Metrics tracking and analysis",
                "Physiology and neuroscience applied",
                "1:1 coaching on habits and lifestyle",
              ],
            },
            {
              title: "Applied research",
              subtitle: "Sports science",
              items: [
                "Sports science projects",
                "Data collection in university population",
                "Applied to strength training",
              ],
            },
          ],
          previousLabel: "Previous experience",
          previous: [
            "Coach at CrossFit RockLife",
            "Swimming teacher · Miraflores School",
            "Co-founder of MUR Project (gym)",
            "Local Police corps",
          ],
        },
        {
          tag: "07 / ATHLETE",
          title: "Active athlete",
          paragraphs: [
            "I currently compete in CrossFit. That allows me to stay in direct contact with real performance, apply on myself what I teach, and validate every method through practice.",
          ],
          quote: "I don't work from theory. I work from experience.",
        },
      ],
      approachTitle: "My approach",
      approachIntro:
        "I don't believe in quick fixes. I don't believe in empty motivation. I believe in:",
      approach: [
        "Structured systems",
        "Daily discipline",
        "Measurable progression",
        "Personal responsibility",
      ],
      missionTitle: "My mission",
      missionLines: [
        "Help people leave physical and mental mediocrity behind.",
        "Not just train better. Live better.",
        "MTK System is not about temporary changes. It's about real transformation.",
      ],
    },
    services: {
      eyebrow: "SERVICES",
      title: "Two ways to work with me.",
      mentorship: {
        tag: "MENTORSHIP · FLAGSHIP",
        title: "TOTAL CHANGE",
        subtitle: "Guided transformation · filter access",
        items: [
          "Full follow-up",
          "Habit control",
          "Training planning",
          "Continuous evaluation",
          "Direct contact",
          "Real demand",
        ],
        cta: "APPLY NOW",
        tagline: "This is guided transformation.",
      },
      personal: {
        tag: "1:1",
        title: "PERSONAL TRAINING",
        subtitle: "Individual in-person sessions",
        items: [
          "1:1 sessions",
          "Total adaptation to your level",
          "Technical correction",
          "Controlled intensity",
          "Progressive improvement",
        ],
        cta: "BOOK A SESSION",
        tagline: "Train with intent. Not inertia.",
      },
    },
    results: {
      eyebrow: "RESULTS",
      title: "What happens when you apply a real system",
      items: [
        "Visible physical improvement",
        "Fat loss / muscle gain",
        "More energy and mental clarity",
        "Discipline in your day-to-day",
        "Real confidence",
      ],
    },
    testimonials: {
      eyebrow: "TESTIMONIALS",
      title: "Not theory. Results.",
      items: [
        {
          quote:
            "I went from starting and quitting every two months to having a system I sustain every day. The difference wasn't motivation. It was structure.",
          name: "Carlos M.",
          role: "Executive · 7 months in MTK",
        },
        {
          quote:
            "Lost 11 kg of fat, gained real strength, and stopped depending on motivation. It changed how I eat, sleep and work.",
          name: "Lucía R.",
          role: "Doctor · 5 months in MTK",
        },
        {
          quote:
            "Not 'another coach'. Xoel demands, measures and adjusts. The difference with any app or template is brutal.",
          name: "David A.",
          role: "Entrepreneur · 9 months in MTK",
        },
      ],
    },
    limited: {
      eyebrow: "LIMITED ACCESS",
      title: "Not everyone gets in.",
      points: [
        "I work with a small group of people",
        "Every application is reviewed",
        "Only committed profiles are accepted",
      ],
    },
    finalCta: {
      eyebrow: "LAST STEP",
      title: "If you are ready to truly change, apply now.",
      cta: "APPLY TO MTK SYSTEM",
      subcopy: "Selection process · Reply in 24–48h",
    },
    form: {
      eyebrow: "APPLICATION FORM",
      title: "Apply to Total Change",
      subtitle: "Be honest. Vague applications are discarded.",
      labels: {
        name: "Full name",
        email: "Email",
        age: "Age",
        situation: "Current situation (work, routine, fitness level)",
        objective: "Main goal",
        time: "Weekly time available",
        block: "What's holding you back right now?",
        why: "Why do you want to enter MTK?",
      },
      submit: "SUBMIT APPLICATION",
      sending: "Sending…",
      successTitle: "Application received.",
      successCopy:
        "We'll review your application. If you fit, we'll contact you in 24–48h.",
      reset: "SEND ANOTHER",
      feeNoticeTitle: "Commitment fee · €100 refundable",
      feeNoticeCopy:
        "Applying requires a €100 financial commitment (refundable if you don't fit the system). Filters tire-kickers and validates real intent.",
      paying: "Redirecting to secure payment…",
      paySubmit: "PAY & APPLY · €{amount}",
      placeholders: {
        name: "Your name",
        email: "you@email.com",
        age: "e.g. 32",
        situation: "Tell me your day-to-day, profession, habits and current level…",
        objective: "What you want to achieve in the next 6 months",
        time: "e.g. 4–5h weekly",
        block: "What has stopped you from sustaining it",
        why: "Why now, why MTK, what you're willing to do",
      },
    },
    footer: {
      tagline: "Mindset · Training · Knowledge",
      copy: "Guided transformation system. Limited access. Committed people only.",
      rights: "All rights reserved.",
    },
    admin: {
      loginTitle: "Admin Access",
      loginSubtitle: "Sign in to review applications.",
      email: "Email",
      password: "Password",
      login: "SIGN IN",
      loggingIn: "Signing in…",
      dashboardTitle: "APPLICATIONS PANEL",
      logout: "Logout",
      filterAll: "All",
      filterPending: "Pending",
      filterAccepted: "Accepted",
      filterRejected: "Rejected",
      filterPaid: "Paid",
      filterUnpaid: "Unpaid",
      noApps: "No applications yet.",
      view: "View",
      accept: "Accept",
      reject: "Reject",
      reset: "Reset",
      delete: "Delete",
      saveNotes: "Save Notes",
      notes: "Internal notes",
      total: "Total",
      pending: "Pending",
      accepted: "Accepted",
      rejected: "Rejected",
      paid: "Paid",
      paidBadge: "PAID",
      unpaidBadge: "UNPAID",
    },
    blog: {
      title: "Blog",
      readMore: "Read article",
      backToBlog: "← Back to Blog",
      noPosts: "Coming soon...",
      by: "By",
      newPost: "Create blog",
      publish: "Publish",
      unpublish: "Unpublish",
      draft: "Draft",
      published: "Published",
      titleLabel: "Title",
      excerptLabel: "Excerpt (optional)",
      contentLabel: "Content",
      authorLabel: "Author",
      save: "Save",
      saving: "Saving…",
      cancel: "Cancel",
      confirmDelete: "Delete this article?",
      manageBlog: "BLOG MANAGEMENT",
      noBlogPosts: "No articles yet.",
    },
  },
};

import React, { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mtk_lang") || "es");
  useEffect(() => {
    localStorage.setItem("mtk_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
}
